import confetti  from 'canvas-confetti';


const confettiHelpers = {

	reset(){
		confetti.reset();
	},

	randomInRange(min, max) {
        return Math.random() * (max - min) + min;
    },

	bgHappy(sec, skew){
		const $this = this;
	    let duration = sec * 1000;
	    let animationEnd = Date.now() + duration;
	    if(skew == undefined) skew = 1;

	    let colors = ['#67AEF4', '#ff7c00', '#ffc600', '#a0e3ad'];
	    let shapes = ['circle', 'square', 'square'];

	    (function frame() {
	        let timeLeft = animationEnd - Date.now();
	        let ticks = Math.max(200, 500 * (timeLeft / duration));
	        skew = Math.max(0.8, skew - 0.001);

	        let scalar = $this.randomInRange(0.5, 1);
	        confetti({
	            particleCount: 1,
	            startVelocity: 0,
	            ticks: ticks,
	            resize: true,
	            useWorker: true,
	            gravity: 1,
	            origin: {
	                x: Math.random(),
	                // since particles fall down, skew start toward the top // y: (Math.random() * skew) - 0.2
	                y: (Math.random() * skew) - 0.2
	            },
	            colors: [colors[Math.floor(Math.random() * colors.length)]],
	            shapes: [shapes[Math.floor(Math.random() * shapes.length)]],
	            scalar: scalar
	        });

	        if (timeLeft > 0) {
	            requestAnimationFrame(frame);
	        }
	    }());
	},

	fireworks(sec){
		const $this = this;
		let duration = sec * 1000;
		let animationEnd = Date.now() + duration;
		let defaults = { 
			startVelocity: 30, spread: 360, ticks: 60, zIndex: 1000, 
		};

		let interval = setInterval(function() {
			let timeLeft = animationEnd - Date.now();

			if (timeLeft <= 0) {
			  return clearInterval(interval);
			}

			let particleCount = 50 * (timeLeft / duration);
			// since particles fall down, start a bit higher than random
			confetti(Object.assign({}, defaults, { particleCount, origin: { x: $this.randomInRange(0.1, 0.3), y: Math.random() - 0.2 } }));
			confetti(Object.assign({}, defaults, { particleCount, origin: { x: $this.randomInRange(0.7, 0.9), y: Math.random() - 0.2 } }));
		}, 250);
	},


	dandelion(){
		const $this = this;

		// confetti({
		// 	angle: 150,
		// 	spread: $this.randomInRange(50, 70),
		// 	particleCount: 400,
		// 	origin: { y: 0.25, x: 0.85 },
		// 	startVelocity: 100,
		// 	colors: ['#ffffff'],
  //   		shapes: ['circle'],
  //   		scalar: 0.7,
  //   		drift: $this.randomInRange(-0.4, 0.4),
  //   		decay: 0.8,
		// });
	}

}

export default confettiHelpers